<template>
  <div id="xy_app">
    <header class="my-header xyShodow">
      <div class="my-header-back" @click="close()"></div>
      <div class="my-header-title" v-text="title"></div>
    </header>
    <div class="xyContent" v-html="htmlStr"></div>
  </div>
</template>
<style scoped>
@import "./xyInfo.css";
</style>
<script>
export default {
  name: "xyInfo",
  data() {
    return {
      title: '',
      htmlStr:''
    };
  },
  mounted() {
      let info = this.$route.params.info;
      if(info.type==2){
          this.title='隐私协议'
      }else{
          this.title='用工协议'
      }
      this.htmlStr=info.content;
  },
  methods: {
    close() {
      this.$parent.pageBack();
      this.$parent.loginShow=true;
    },
  },
};
</script>